import './CategoriesSiblings.css';
import React from 'react';
import { get } from '../../utils';
// import { Link } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { injectImageResolution } from '../../utils';
import { commonStyles, ltrStyles, rtlStyles } from '../47_CategoriesChildren/CategoriesChildren';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import RouterLink from '../atoms/RouterLink/RouterLink';
export const CategoriesSiblings = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.warn('CategoriesSiblings component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [CategoriesSiblings component is empty: please provide data source]");
    }
    return null;
  }
  const titleClickAnalytics = get(fields, 'data.titleClickAnalytics');
  const bannerClickAnalytics = get(fields, 'data.bannerClickAnalytics');
  const learnMoreAnalytics = get(fields, 'data.learnMoreAnalytics');
  const hasTitle = Boolean(get(fields, 'data.settings.title.value'));
  const hasItems = Boolean(get(fields, 'data.categories.parent.children.length'));
  const selfId = get(fields, 'data.categories.selfId', null);
  const items = hasItems ? fields.data.categories.parent.children : [];
  const numberOfCategoriesToRender = Number(get(fields, 'data.settings.numberOfCategories.value', 30));
  const randomOrder = Boolean(get(fields, 'data.settings.randomOrder.value'));
  const hasDescription = Boolean(get(fields, 'data.settings.description'));
  const ctaLabel = get(fields, 'data.settings.ctaLabel.value');
  const ctaLink = get(fields, 'data.settings.ctaLink.jss.value.href');
  const ctaItemLabel = get(fields, 'data.dictionary.dictionaryValues.0.phrase.jss.value');
  const filteredItems = items.filter(i => i.headerImage && i.headerImage.src && i.id !== selfId);
  /*eslint-disable */

  const [randomizedItems, setRandomizedItems] = React.useState([]);
  React.useEffect(() => {
    setRandomizedItems(randomOrder ? filteredItems.sort(() => filteredItems.length / 10 - Math.random()) : filteredItems);
  }, []);
  /*eslint-disable */

  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "subcategories subcategories--general"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 sub__title",
    field: fields.data.settings.title
  }), hasDescription && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "sub__desc body-small",
    field: fields.data.settings.description
  }), /*#__PURE__*/React.createElement("div", {
    className: "row sub-body"
  }, randomizedItems.slice(0, numberOfCategoriesToRender).map(item => {
    if (!item.pageName.value || item.pageName.value === '$name') {
      return null;
    }
    if (item.pageTitle.value) {
      return /*#__PURE__*/React.createElement(RouterLink, {
        href: item.url,
        key: item.url,
        className: `box-sub box-shadow ${item.pageTitle.value !== undefined ? 'has-description' : ''}`
      }, /*#__PURE__*/React.createElement(RouterLink, {
        href: item.url,
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), item.name);
        },
        title: item.pageName && item.pageName.value,
        className: "sub-img"
      }, /*#__PURE__*/React.createElement(LazyPicture, {
        className: "box__picture",
        useEmptyPlaceholder: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 1024px)",
        srcSet: injectImageResolution(item.headerImage.src, 1020, 765)
      }), /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: injectImageResolution(item.headerImage.src, 304, 304)
      }), /*#__PURE__*/React.createElement("img", {
        className: "box__img",
        src: injectImageResolution(item.headerImage.src, 152, 152),
        alt: item.headerImage.alt
      }))), /*#__PURE__*/React.createElement("div", {
        className: "box__title"
      }, item.pageName && item.pageName.value && /*#__PURE__*/React.createElement(RouterLink, {
        href: item.url,
        className: "link-text-decoration",
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(titleClickAnalytics, params), item.name);
        }
      }, /*#__PURE__*/React.createElement(Text, {
        tag: "h4",
        className: "h4 no-margin title__txt",
        field: item.pageName
      })), item.pageTitle && item.pageTitle.value && /*#__PURE__*/React.createElement(Text, {
        tag: "p",
        className: "body-small box-desc",
        field: item.pageTitle
      }), ctaItemLabel && item.url && /*#__PURE__*/React.createElement("div", {
        className: "txt-more"
      }, /*#__PURE__*/React.createElement(RouterLink, {
        className: "btn-tertiary",
        href: item.url
      }, /*#__PURE__*/React.createElement("span", {
        className: "btn-tertiary__text"
      }, ctaItemLabel), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
        className: "btn-link__icon btn-link-icon"
      }) : /*#__PURE__*/React.createElement(ChevronRight, {
        className: "btn-link__icon btn-link-icon"
      })))));
    }
    return null;
  })), ctaLabel && ctaLink && /*#__PURE__*/React.createElement(RouterLink, {
    className: `btn btn-secondary`,
    href: ctaLink,
    title: `${ctaLabel}`
  }, ctaLabel)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${commonStylesComponent}`
  }, children);
};
const commonStylesComponent = "cvg25ae";
export default CategoriesSiblings;